<template>
    <div>
        <div class="title">发票信息
            <RadioGroup v-model="form.invoiceType" class="ml15" @on-change="getInputInfo">
                <Radio label="PLAIN" :disabled="disabled">普票（电子）</Radio>
                <Radio label="VAT" :disabled="disabled">专票（纸质）</Radio>
                <Radio label="NOT" :disabled="disabled">不开发票</Radio>
            </RadioGroup>
        </div>
        <Form :model="form" :label-width="150" class="mt15" ref="invoice"
            :rules="form.invoiceType == 'VAT' ? invoiceValidate : null" v-if="form.invoiceType != 'NOT'"
            :key="form.invoiceType">
            <FormItem label="公司名称" class="w600" prop="invoiceName">
                {{ form.invoiceName }}
            </FormItem>
            <FormItem label="统一社会信用代码" class="w600" prop="invoiceUniqueCode">
                {{ form.invoiceUniqueCode }}
            </FormItem>
            <FormItem label="开户地址" class="w600" prop="invoiceAddress">
                <Input v-model="form.invoiceAddress" placeholder="请输入开票地址" :maxlength="50"></Input>
            </FormItem>
            <FormItem label="联系电话" class="w600" prop="invoicePhone">
                <Input v-model="form.invoicePhone" placeholder="请输入开票电话" :maxlength="20"></Input>
            </FormItem>
            <FormItem label="开户行" class="w600" prop="openingBankName">
                <Input v-model="form.openingBankName" placeholder="请输入开户行" :maxlength="30"></Input>
            </FormItem>
            <FormItem label="对公账号" class="w600" prop="openingBankAccount">
                <Input v-model="form.openingBankAccount" placeholder="请输入对公账号" :maxlength="30"></Input>
            </FormItem>
            <FormItem label="电子邮箱" class="w600" prop="invoiceDeliverEmail">
                <Input v-model="form.invoiceDeliverEmail" placeholder="请输入电子邮箱" :maxlength="100"></Input>
            </FormItem>
            <FormItem label="邮寄地址" class="w600" prop="invoiceDeliverAddress">
                <Input v-model="form.invoiceDeliverAddress" placeholder="请输入邮寄地址" :maxlength="100"></Input>
            </FormItem>
        </Form>
    </div>
</template>
<script>
export default {
    props: {
        info: Object,
        formInfo: Object
    },
    data() {
        const validatePhone = (rule, value, callback) => {
            const mobileReg = /^(([1][3,4,5,7,8]\d{9})|([0]\d{10,11})|(\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/
            const phoneReg = /^\d{4}-\d{8}|\d{4}-\d{7}$/
            if (!value || value === "") { callback(new Error("请输入联系方式")); }
            else if (value.length === 11) {
                if (!mobileReg.test(value)) {
                    callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
                } else {
                    callback();
                }
            }
            else if (value.length === 12 || value.length === 13) {
                if (!phoneReg.test(value)) {
                    callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码1）"))
                } else {
                    callback();
                }
            } else {
                callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
            }
        }
        return {
            form: {
                invoiceType: 'PLAIN'
            },
            invoiceValidate: {
                invoiceAddress: { required: true, message: '请输入开票地址', trigger: 'blur' },
                invoicePhone: { required: true, trigger: 'blur', validator: validatePhone },
                openingBankName: { required: true, message: '请输入开户行', trigger: 'blur' },
                openingBankAccount: { required: true, message: '请输入正确的对公账号', trigger: 'blur' },
                invoiceDeliverEmail: { required: true, message: '邮箱格式错误', trigger: 'blur', type:'email' },
                invoiceDeliverAddress: { required: true, message: '请输入邮寄地址', trigger: 'blur' }
            },
            orderType: this.$route.query.orderType || '',
            isReset: this.$route.query.reset || '', // 是否重新投保

        }
    },
    computed: {
        disabled() {
            return false
            // if (this.orderType == 1 || this.isReset == 1) return false
            // else return !this.form.invoiceName || !this.form.invoiceUniqueCode
        }
    },
    watch: {
        info(val) {
            this.form = val;
            this.form.invoiceName = val.companyName || val.invoiceName || '';
            this.form.invoiceUniqueCode = val.idNumber || val.invoiceUniqueCode || '';
            this.form.invoiceType = val.invoiceType
            if (val.invoiceType) {
                this.form.invoiceType = val.invoiceType.toString()
            } else {
                this.form.invoiceType = 'NOT'
            }
        },
        formInfo(val) {
            this.setInfo(val)
        }
    },
    created() {
        this.form = this.info
        if (this.form.invoiceType) {
            this.form.invoiceType = this.form.invoiceType.toString()
        } else {
            this.form.invoiceType = 'NOT'
        }
        this.form.invoiceName = this.info.companyName || this.info.invoiceName || '';
        this.form.invoiceUniqueCode = this.info.organizationCode || this.info.invoiceUniqueCode || '';
    },
    methods: {
        setInfo(obj) {
            this.$set(this.form, 'invoiceType', obj.invoiceInfo.invoiceType)
            if (obj.invoiceInfo.invoiceType != 'NOT') {
                this.$set(this.form, 'invoiceName', obj.invoiceInfo.invoiceName)
                this.$set(this.form, 'invoiceUniqueCode', obj.invoiceInfo.invoiceUniqueCode)
                this.$set(this.form, 'invoiceAddress', obj.invoiceInfo.invoiceAddress)
                this.$set(this.form, 'invoicePhone', obj.invoiceInfo.invoicePhone)
                this.$set(this.form, 'openingBankName', obj.invoiceInfo.openingBankName)
                this.$set(this.form, 'openingBankAccount', obj.invoiceInfo.openingBankAccount)
                this.$set(this.form, 'invoiceDeliverEmail', obj.invoiceInfo.invoiceDeliverEmail)
                this.$set(this.form, 'invoiceDeliverAddress', obj.invoiceInfo.invoiceDeliverAddress)

            }

        },
        val() {
            console.log(888)
            return new Promise((resolve, reject) => {
                if (this.form.invoiceType == 'NOT') {
                    resolve({
                        invoiceType: 'NOT'
                    })
                    return;
                }
                console.log(999)

                this.$refs.invoice.validate(valid => {
                    console.log(1000)

                    resolve(valid ? this.form : false)
                })
            })
        },
        /*获取用户输入的信息*/
        getInputInfo(value) {
            if (value == 'NOT') return;
            this.$set(this.form, 'invoiceAddress', this.form.invoiceAddress || this.form.address)
            this.$set(this.form, 'invoicePhone', this.form.invoicePhone || this.form.contactsPhone)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/common/Invoice.vue